export default "__VITE_ASSET__f098c95b__"